import React from 'react';
import { Box, BoxExtendedProps, CloseIcon, RawButton, Text } from '@common-fe/common-fe';

interface Props extends BoxExtendedProps {
  testId: string;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}

const OptionalFieldsWrapper: React.FC<Props> = ({ testId, title, onClose, children, ...props }) => {
  return (
    <Box {...props}>
      <Box direction="row" gap="spacing2">
        <Text weight={700}>{title}</Text>
        <RawButton
          data-testId={`${testId}_delete-button`}
          onClick={onClose}
        >
          <Box margin="auto">
            <CloseIcon color="danger" size="16px" />
          </Box>
        </RawButton>
      </Box>

      <Box margin={{ top: 'spacing8' }}>
        {children}
      </Box>
    </Box>
  );
};

export default OptionalFieldsWrapper;
